export interface ArticlePage {
	category: string;
	date: string;
	thumbnail: string;
	articleTitle: string;
	subTitle: string;
	description: string;
	videoUrl: string;
	articleType: string;
	altText: string;
	pageUrl: string;
	pdfUrl: string;
	externalUrl: string;
	dateCompare: string;
}

export enum ViewType {
	card,
	list,
}

export interface PageModel {
	articlePages: ArticlePage[];
	title: string;
	description: string;
	cardViewOnly: string;
	allOptionText: string;
	filterBy: string;
	clearFilterText: string;
	dateLabel: string;
	titleLabel: string;
	categoryLabel: string;
	typeLabel: string;
	hideDatesAndCategories: string;
}

export enum ArticleTypes {
	Article = 'Article',
	Video = 'Video',
	PDF = 'PDF',
	ExternalLink = 'External Link',
	StandardLink = 'Link',
}